<template>
  <div>
    <mdb-form-inline class="active-cyan active-cyan-2">
      <mdbIcon icon="search" />
      <input
        v-model="filterText"
        @keyup="doFilter"
        class="form-control mr-sm-2 ml-3 mx-3 w-50"
        type="text"
        :placeholder="placeholder"
      />
      <mdb-btn size="sm" color="indigo" @click="doFilter"
        >{{ $t("search") }}<mdb-icon icon="search" class="ml-1"
      /></mdb-btn>
      <mdb-btn size="sm" color="indigo" @click="resetFilter"
        >{{ $t("reset_search") }}<mdb-icon icon="undo" class="ml-1"
      /></mdb-btn>
    </mdb-form-inline>
  </div>
</template>

<script>
import { mdbIcon, mdbBtn, mdbFormInline } from "mdbvue";
export default {
  name: "FilterBar",
  components: {
    mdbIcon,
    mdbBtn,
    mdbFormInline
  },
  props: {
    placeholder: {
      type: String,
      default: "Etsi"
    }
  },
  data() {
    return {
      filterText: ""
    };
  },
  methods: {
    doFilter() {
      this.$emit("filter-set", this.filterText);
    },
    resetFilter() {
      this.filterText = ""; // clear the text in text input
      this.$emit("filter-reset");
    }
  }
};
</script>

<style scoped>
.active-cyan input[type="text"] {
  border: 1px solid indigo;
  box-shadow: 0 1px 0 0 indigo;
}
</style>
